import { createFileRoute } from "@tanstack/react-router";
import DealerMetaAds from "@/pages/DealerMetaAds";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/dealer-demo/")({
  head: () => routeHead("/uk/dealer-demo/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealerMetaAds />
  );
}
